// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>

<div class="click-through" style="position:absolute; width: 100%; height: 100%; display:flex; align-items: flex-end;">
  <toolbar v-if="$store.state.showMainToolBar" class="get-click"></toolbar>
  <observing-panel></observing-panel>
  <template v-for="(item, i) in pluginsGuiComponents">
    <component :is="item" :key="i"></component>
  </template>
  <template v-for="(item, i) in dialogs">
    <component :is="item" :key="i + pluginsGuiComponents.length"></component>
  </template>
  <locationDisplay />
  <selected-object-info style="position: absolute; top: 48px; left: 0px; width: 380px; max-width: calc(100vw - 12px); margin: 6px" class="get-click"></selected-object-info>
  <progress-bars style="position: absolute; bottom: 100px; right: 12px;"></progress-bars>
  <bottom-bar style="position:absolute; width: 100%; justify-content: flex-end; bottom: 0; display:flex; margin-bottom: 0px" class="get-click"></bottom-bar>
  <div v-if="!app" class="copyright" ref="copyright">
    天文通 闽ICP备19014227号-2
  </div>
</div>

</template>

<script>
import Toolbar from '@/components/toolbar-new.vue'
import BottomBar from '@/components/bottom-bar-new.vue'
import SelectedObjectInfo from '@/components/selected-object-info-new.vue'
import ProgressBars from '@/components/progress-bars'

import DataCreditsDialog from '@/components/data-credits-dialog.vue'
import ViewSettingsDialog from '@/components/view-settings-dialog-new.vue'
import PlanetsVisibility from '@/components/planets-visibility-new.vue'
import LocationDialog from '@/components/location-dialog-new.vue'
import locationDisplay from './location-display.vue'
import ObservingPanel from '@/components/observing-panel.vue'
    import utils from '../../common/utils/utils'


export default {
  data: function () {
    return {
      app:false
    }
  },
  methods: {
  },
  mounted:function(){
      this.app = utils.getUrlParams('app');
  },
  computed: {
    pluginsGuiComponents: function () {
      let res = []
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.guiComponents) {
          res = res.concat(plugin.guiComponents)
        }
      }
      return res
    },
    dialogs: function () {
      let res = [
        'data-credits-dialog',
        'view-settings-dialog',
        'planets-visibility',
        // 'location-dialog'
      ]
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.dialogs) {
          res = res.concat(plugin.dialogs.map(d => d.name))
        }
      }
      return res
    }
  },
  // components: { Toolbar, BottomBar, DataCreditsDialog, ViewSettingsDialog, PlanetsVisibility, SelectedObjectInfo, LocationDialog, ProgressBars, ObservingPanel }
  components: { Toolbar, BottomBar, DataCreditsDialog, ViewSettingsDialog, PlanetsVisibility, SelectedObjectInfo, ProgressBars, ObservingPanel, locationDisplay }
}
</script>

<style>
  .copyright {
    position: fixed;
    bottom: 4px;
    right: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }
  @media screen and (max-width: 960px) {
    .copyright {
      position: fixed;
      bottom: 4px;
      right: 10px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
  @media screen and (max-width: 500px) {
    .copyright {
      position: fixed;
      bottom: 6px;
      right: 10px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
</style>
